<template>
    <div class="widget" :class="{horizontal: !square, square}" v-if="frame">
        <iframe v-if="square" style="border: none;" :src="frame"></iframe>
        <iframe v-else :src="frame" width="100%" height="150px" style="border:none"></iframe>
    </div>
</template>

<script>
export default {
    name: 'WidgetOne',
    props: {
        square: {
            default: false,
        }
    },
    computed: {
        frame() {
            if( this.square ) {
                return this.$store.getters['settings/path'](["widgets", "square_widget"])
            }
            return this.$store.getters['settings/path'](["widgets", "horizontal_widget"])
        }
    },
    mounted() {
        this.$store.dispatch('settings/getAll')
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/queries";
@import "@/assets/scss/colors";

div {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    border: solid $color-betano;
    border-width: 1px 0;
    box-shadow: 0px 0px 10px 1px rgba($color-betano, 0.80);

    @include media(sm) {
        max-width: var(--content-width);
        border-width: 1px;
    }

    iframe {
        height: 100%;
        width: 100%;
    }

    img {
        margin: auto;
        width: 100%;
        max-width: 100%;
    }
}
</style>
